import React from "react";
import { Router, Switch, Route, Link } from "react-router-dom";

const RouterContext = React.createContext({
    Router,
    Switch,
    Route,
    Link
});

export default RouterContext;